import DistrictLeaderApi from './DistrictLeaderApi';
export default DistrictLeaderApi;
